import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Text,
  Textarea,
} from "@chakra-ui/react";
import Layout from "../../components/dashboard/Layout";
import LogoutMenu from "../../components/dashboard/Layout/logout-menu";
import { customNotifyPracticeRequest } from "../../modules/admin-modules/announcements/Actions";

const CustomNotifyPractice = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.userData);
  const userLoading = useSelector((state) => state.user.isLoading);
  const customNotifyLoading = useSelector(
    (state) => state.announcements.customNotifyPracticeLoading
  );

  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");

  const isSuperAdmin =
    user?.role &&
    Array.isArray(user.role) &&
    user.role[0]?.name === "Super Admin";

  React.useEffect(() => {
    if (userLoading) return;
    if (user?.role && Array.isArray(user.role) && !isSuperAdmin) {
      navigate("/dashboard/students");
    }
  }, [user, userLoading, isSuperAdmin, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!title.trim()) return;
    if (!message.trim()) return;
    dispatch(
      customNotifyPracticeRequest({
        title: title.trim(),
        message: message.trim(),
      })
    );
    setTitle("");
    setMessage("");
  };

  if (userLoading || !user?.role) return null;
  if (!isSuperAdmin) return null;

  return (
    <Layout>
      <Box minHeight="400px">
        <Flex
          w="100%"
          my="30px"
          justifyContent="space-between"
          alignItems="center"
          position="relative"
          zIndex="10000000"
        >
          <Text fontSize="24px" fontWeight="600" color="main_1">
            إشعار تدريب مخصص / Custom Notify Practice
          </Text>
          <LogoutMenu />
        </Flex>

        <Box
          as="form"
          onSubmit={handleSubmit}
          maxW="600px"
          p={6}
          bg="white"
          borderRadius="lg"
          boxShadow="md"
          border="1px solid"
          borderColor="gray.200"
        >
          <FormControl isRequired mb={4}>
            <FormLabel>العنوان / Title</FormLabel>
            <Input
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Enter title..."
              size="lg"
            />
          </FormControl>

          <FormControl isRequired mb={6}>
            <FormLabel>الرسالة / Message</FormLabel>
            <Textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Enter message..."
              rows={6}
              size="lg"
            />
          </FormControl>

          <Button
            type="submit"
            colorScheme="blue"
            color="white"
            isLoading={customNotifyLoading}
            loadingText="جاري الإرسال..."
            isDisabled={!title.trim() || !message.trim()}
          >
            إرسال / Send
          </Button>
        </Box>
      </Box>
    </Layout>
  );
};

export default CustomNotifyPractice;
